module.exports = __webpack_public_path__ + "img/ejuice.ddaf0448.png";